import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
export function Pricing() {
  const tiers = [{
    name: 'Start',
    summary: 'One outcome, one system, one fast win.',
    detail: 'A single system live — like "never miss a lead" (voice + instant follow-up). The simplest way to see AI earn its keep.'
  }, {
    name: 'Grow',
    summary: 'One outcome, built out end-to-end.',
    detail: 'A full offer deployed — for example, all of "Get more business" — plugging the leaks and creating new demand.'
  }, {
    name: 'Deep end',
    summary: 'Multiple outcomes, or agentic AI.',
    detail: 'Several systems running together, or AI running whole workflows — for when the early wins are proven and you want to go further.'
  }];
  return <section id="pricing" className="py-20 bg-white border-t border-gray-100" data-id="element-307">
      <div className="container mx-auto px-4" data-id="element-308">
        <div className="text-center mb-16" data-id="element-309">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-310">
            Simple, low-risk to start
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto mb-6 rounded-full" data-id="element-311"></div>
          <p className="max-w-2xl mx-auto text-gray-600 text-lg" data-id="element-312">
            Every engagement is a setup fee plus a monthly retainer, sized to
            the scope of what we build. You start small, prove it, and expand
            from there.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-313">
          {tiers.map((tier, index) => <div key={index} className={`rounded-xl p-8 flex flex-col border shadow-sm ${index === 1 ? 'bg-gray-900 border-gray-900 text-white' : 'bg-gray-50 border-gray-100'}`} data-id="element-314">
              <div className={`text-xs font-semibold uppercase tracking-wider mb-3 ${index === 1 ? 'text-blue-300' : 'text-blue-600'}`} data-id="element-315">
                {tier.name}
              </div>
              <h3 className={`text-xl font-bold mb-3 ${index === 1 ? 'text-white' : 'text-gray-900'}`} data-id="element-316">
                {tier.summary}
              </h3>
              <p className={`text-sm leading-relaxed ${index === 1 ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-317">
                {tier.detail}
              </p>
            </div>)}
        </div>

        <div className="max-w-3xl mx-auto text-center" data-id="element-318">
          <p className="text-gray-600 mb-2 flex items-center justify-center gap-2" data-id="element-319">
            <CheckIcon size={18} className="text-blue-600 shrink-0" data-id="element-320" />
            We can tie part of our fee to the results — appointments booked,
            leads qualified — for the risk-averse.
          </p>
          <p className="text-sm text-gray-500 mb-8" data-id="element-321">
            Exact numbers depend on scope. We'll walk you through them on the
            free audit — no obligation.
          </p>
          <a href="#contact" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all font-semibold shadow-lg shadow-blue-600/20 hover:shadow-xl hover:-translate-y-0.5" data-id="element-322">
            Start with a free audit <ArrowRightIcon size={18} data-id="element-323" />
          </a>
        </div>
      </div>
    </section>;
}